import { useMutation, useQueryClient } from '@tanstack/react-query';

import { REMOVE_SAVED_PAYMENT_METHOD_ENDPOINT } from 'reservations/base/constants/endpoints';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { useErrorSnackbar } from 'reservations/base/hooks/useSnackbar';
import { type RequestError, restClient } from 'utility/restClient';

type DeleteSavedPaymentMethodMutationProps = {
  handleSuccess: () => void;
};

export function useDeleteSavedPaymentMethodMutation({
  handleSuccess
}: DeleteSavedPaymentMethodMutationProps) {
  const queryClient = useQueryClient();
  const enqueueErrorSnackbar = useErrorSnackbar();

  return useMutation<void, RequestError, Record<string, string>>({
    mutationFn: async ({ paymentMethodId }) => {
      const endpoint = `${buildBentoboxApiEndpoint(
        REMOVE_SAVED_PAYMENT_METHOD_ENDPOINT
      )}/${paymentMethodId}`;

      const requestOptions = {};
      return restClient.delete(endpoint, requestOptions);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['currentUser'],
        exact: false,
        refetchType: 'none'
      });
      handleSuccess();
    },
    onError: error => {
      console.error('error removing saved payment method', error);
      enqueueErrorSnackbar(
        'DELETE_SAVED_PAYMENT_METHOD_ERROR_SNACKBAR',
        'Sorry, we encountered an error removing this payment method. Please try again.'
      );
    }
  });
}
